import { c as _c } from "react/compiler-runtime";
import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import NextImage from "next/image";
import { ReactNode } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
const messages = defineMessages({
  mobileGateTitle: {
    id: "mobileGate.title",
    defaultMessage: "Larger screen required"
  },
  mobileGateBody: {
    id: "mobileGate.body",
    defaultMessage: "This application is currently only available on tablets and computers."
  }
});
interface MobileGateProps {
  children: ReactNode;
}
export const MobileGate = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "flex",
      md: "none"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NextImage src="/logo.svg" alt="Mobilysis" height={40} width={200} priority={true} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Heading as="h1" size="md" data-testid="mobile-gate-title"><FormattedMessage {...messages.mobileGateTitle} /></Heading>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box minH="100vh" display={t1} alignItems="center" justifyContent="center" px="6" bg="background" data-testid="mobile-gate"><VStack gap="4" textAlign="center" maxW="sm">{t2}{t3}<Text fontSize="md" color="grey.700" data-testid="mobile-gate-body"><FormattedMessage {...messages.mobileGateBody} /></Text></VStack></Box>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      base: "none",
      md: "contents"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <>{t4}<Box display={t5} data-testid="mobile-gate-children">{children}</Box></>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};